/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SaleFulfillmentGroupResponseDto } from './SaleFulfillmentGroupResponseDto';
export type SaleFulfillmentDetailResponseDto = {
    /**
     * Overall logistics status of the sale
     */
    fulfillmentStatus: SaleFulfillmentDetailResponseDto.fulfillmentStatus;
    /**
     * One entry per remote source location involved in the sale
     */
    groups: Array<SaleFulfillmentGroupResponseDto>;
};
export namespace SaleFulfillmentDetailResponseDto {
    /**
     * Overall logistics status of the sale
     */
    export enum fulfillmentStatus {
        NOT_REQUIRED = 'NOT_REQUIRED',
        PENDING = 'PENDING',
        COMPLETED = 'COMPLETED',
        FAILED = 'FAILED',
        CANCELLED = 'CANCELLED',
    }
}

